import Route from "@ember/routing/route";
import { service } from "@ember/service";

export default class IpsRoute extends Route {
  @service availableServices;

  buildRouteInfoMetadata() {
    return { jumpable: true };
  }

  beforeModel() {
    this.availableServices.requireAccessTo(this, "networking");
  }
}
